import React, { useState } from "react";
import "./Alumni.css";
import AlumniImg1 from "../../assets/Alumni_imgs/ALMS.jpg";
import AlumniImg2 from "../../assets/Alumni_imgs/Alumni_img2.jpg";
import AlumniImg4 from "../../assets/Alumni_imgs/Alumni_img4.jpg";
import FeatureImg from "../../assets/Alumni_imgs/connection.jpg";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AlumniSlider from "./AlumniSlider";

function AlumniData() {
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <div className="alumni-container">
      <section className="alumni-header">
        <div className="header-text">
          <h3>Stay Connected, Forever!</h3>
          <p>Building lifelong bridges between alumni and their alma mater.</p>
        </div>
        <div className="header-img">
          <img src={AlumniImg1} alt="Alumni" />
        </div>
      </section>

      <p className="alumni-quote">
        "Reconnect with your roots and build meaningful connections with alumni,
        the ultimate platform designed to keep alumni and colleges closer than
        ever, whether it's networking, events, or giving back to the institution
        that shaped your journey, we’ve got it all covered."
      </p>

      <section className="alumni-features">
        <div className="feature-img">
          <img src={FeatureImg} alt="Feature" />
        </div>
        <div className="accordion-container">
          {[
            {
              label: "Exclusive Alumni Network",
              content:
                "Join Our Exclusive Alumni Network: Connect with a vibrant community of accomplished professionals, industry leaders, and innovators. This platform offers unparalleled opportunities to network, collaborate, and share insights, fostering personal and professional growth. Stay informed about the latest trends, access exclusive resources, and participate in events designed to enhance your career and expand your horizons. Be a part of a thriving network that empowers success and builds lifelong connections.",
            },
            {
              label: "Real-time Updates",
              content:
                "Stay Ahead with Real-Time Updates: Receive instant notifications to keep you informed and in control. Our dynamic system ensures you're always up-to-date with the latest developments, whether it's crucial announcements, upcoming events, or breaking news. Seamlessly stay connected and never miss a beat, empowering you to make timely decisions and maintain an edge in your endeavors.",
            },
            {
              label: "Mentorship Programs",
              content:
                "Our Mentorship Programs: Unlock your potential by connecting with experienced industry professionals who offer personalized guidance and valuable insights. These programs are designed to foster growth, enhance skills, and provide real-world expertise to help you navigate your career path. Build meaningful relationships with mentors, gain practical knowledge, and access a wealth of resources to achieve your personal and professional goals with confidence.",
            },
            {
              label: "Event Management",
              content:
                "Expert Event Management: Experience seamless planning and flawless execution with our professional event management services. From concept to completion, our team handles every detail with precision, ensuring your events are memorable, impactful, and stress-free. Whether it’s a corporate conference, a social gathering, or a grand celebration, we bring creativity, expertise, and meticulous attention to detail to make your vision a reality. Trust us to deliver exceptional experiences that leave a lasting impression.",
            },
            {
              label: "Career Support",
              content:
                "Comprehensive Career Support: Empower your professional journey with personalized guidance tailored to help you excel in job searches and career advancement. Our expert advisors provide strategic insights, resume refinement, interview preparation, and networking opportunities to align your skills with your aspirations. Whether you're starting your career, switching industries, or aiming for the next big role, our dedicated support equips you with the tools and confidence to achieve your goals and thrive in a competitive job market.",
            },
          ].map((item, index) => (
            <Accordion
              key={index}
              expanded={expanded === `panel${index + 1}`}
              onChange={handleChange(`panel${index + 1}`)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{item.label}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{item.content}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </section>

      <section className="why-choose-us">
        <div className="why-text">
          <h4>Why Choose Us?</h4>
          <br/>
          <p>
            Simplified navigation for effortless connectivity. Secure and
            private platform to keep your information safe. Dedicated support
            for both alumni and colleges.
          </p>
        </div>
        <div className="why-img">
          <img src={AlumniImg2} alt="Why Choose Us" />
        </div>
      </section>

      <section className="alumni-legacy">
        <h2>"From Caps to Connections."</h2>
        <img src={AlumniImg4} alt="Legacy" />
        <br/>
        <br/>
        <p>Stay linked to your alma mater and build a legacy together.</p>
        <br/>
      </section>

      <section className="alumni-slider">
        <AlumniSlider />
      </section>
    </div>
  );
}

export default AlumniData;
